<template>
  <div class="hostCampaign">
    <div class="hostCampaign__header">
      <h1 class="medium-title">All Campaign</h1>
    </div>
    <div class="hostCampaign__subheader">
      <div class="hostCampaign__subheader__search">
        <i class="icon-search"></i>
        <input v-model="searchValue" class="subhead" type="text" placeholder="Search Campaign Name">
      </div>
      <div class="hostCampaign__subheader__filter">
        <div class="years">
          <adx-selectdropdown @selected="selectYear" :label="`All Years`" :options="yearList" />
        </div>
        <div class="from">
          <adx-selectdropdown @selected="selectFrom" :label="`From Month`" :options="fromMonth" />
        </div>
        <div class="to">
          <adx-selectdropdown @selected="selectTo" :label="`To Month`" :options="toMonth" />
        </div>
        <div class="status">
          <adx-selectdropdown @selected="selectStatus" :label="`All Status`" :options="statusList" />
        </div>
      </div>
    </div>
    <div class="hostCampaign__listing">
      <template v-if="!isEmpty && !isLoading">
        <adx-list-campaign :items='items' :headers='headers' />
        <adx-pagination
          v-if="items.length > 0"
          @change-page="changePage"
          :max-page="maxPage"
          :selected-page="currentPage"
        />
      </template>
      <adx-empty-selection v-if="isEmpty && !isLoading" />
      <adx-loading v-if="isLoading" slot="loading" />
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import ListCampaign from '@/views/Dashboard/Host/Campaign/ListItems'
import Pagination from '@/components/Pagination'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'adx-dashboard-campaign',
  components: {
    'adx-selectdropdown': SelectDropdown,
    'adx-list-campaign': ListCampaign,
    'adx-pagination': Pagination,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
  },
  props: {

  },
  data() {
    return {
      dropdown: [
        {
          label: 'All Years',
          value: 'value_1'
        },
        {
          label: '2018',
          value: 'value_2'
        },
        {
          label: '2017',
          value: 'value_3'
        }
      ],
      items: [],
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      monthList: [{"id": 0, "value": "", "label": "All Month"},
                {"id": 1, "value": "1", "label": "January"},
                {"id": 2, "value": "2", "label": "February"},
                {"id": 3, "value": "3", "label": "March"},
                {"id": 4, "value": "4", "label": "April"},
                {"id": 5, "value": "5", "label": "May"},
                {"id": 6, "value": "6", "label": "June"},
                {"id": 7, "value": "7", "label": "July"},
                {"id": 8, "value": "8", "label": "August"},
                {"id": 9, "value": "9", "label": "September"},
                {"id": 10, "value": "10", "label": "October"},
                {"id": 11, "value": "11", "label": "November"},
                {"id": 12, "value": "12", "label": "December"}],
      statusList: [
        {
          "id": 1,
          "value": "",
          "label": "All Status"
        },
        {
          "id": 2,
          "value": "active",
          "label": "Active"
        },
        {
          "id": 3,
          "value": "upcoming",
          "label": "Upcoming"
        },
        {
          "id": 4,
          "value": "wfa",
          "label": "Waiting For Approval"
        },
        {
          "id": 5,
          "value": "canceled",
          "label": "Canceled"
        },
        {
          "id": 6,
          "value": "expired",
          "label": "Expired"
        }
      ],
      selectedTo: "",
      selectedFrom: "",
      selectedYear: "",
      selectedStatus: "",
      searchValue: "",
      currentPage: 1,
      maxPage: 1,
      isLoading: false,
      isEmpty: false,
    }
  },
  computed: {
    yearList(){
      let year = moment().year()
      var list = [{"id": 0, "value": "", "label": "All Year"}]
      for (var i = 0; i < 5; i++){
        list.push({"id": i+1, "value": year + i, "label": year + i})
      }
      return list
    },
    fromMonth(){
      var from = this.monthList
      if (this.selectedTo !== ""){
        from = this.monthList.filter(month => parseInt(month.id) == 0 ||
              parseInt(month.id) <= parseInt(this.selectedTo))
      }
      return from
    },
    toMonth(){
      var to = this.monthList
      if (this.selectedFrom){
        to = this.monthList.filter(month => parseInt(month.id) == 0 ||
            parseInt(month.id) >= parseInt(this.selectedFrom))
      }
      return to
    },
    getFilterParams: function () {
      const params = {
        year: this.selectedYear || undefined,
        status: this.selectedStatus || undefined,
        to: this.selectedTo || undefined,
        from: this.selectedFrom || undefined,
        page: this.currentPage || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    }
  },
  watch: {
    searchValue() {
      this.$nextTick(function() {
        this.debouncedloadDataSearch()
      })
    },
    currentPage() {
      this.loadData()
    }
  },
  beforeCreate() {

  },
  created() {
    this.debouncedloadDataSearch = _.debounce(this.loadDataSearch, 1000)
  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      (async () => {
        this.isLoading = true
        const params = {
          ...this.getFilterParams,
          search: this.searchValue
        }
        const response = await api.get(apiV2.hostCampaigns, { params: params, needToken: true })
        if (response.status == 200) {
          const { data } = response

          this.items = data.results
          this.maxPage = data.max_page

        } else {
          this.items = []
        }

        this.isLoading = false
      })();
    },
    loadDataSearch() {
      (async () => {
        this.isLoading = true
        const params = {
          search: this.searchValue
        }
        const response = await api.get(apiV2.hostCampaigns, { params: params, needToken: true })
        if (response.status == 200) {
          const { data } = response

          this.items = data.results
          this.maxPage = data.max_page
          this.currentPage = 1

        } else {
          this.items = []
        }

        this.isLoading = false
      })();
    },
    selectYear(item) {
      this.selectedYear = item.item.value
      this.$nextTick(() => {
        this.loadData()
      });
    },
    selectFrom(item) {
      this.selectedFrom = item.item.value
      this.$nextTick(() => {
        this.loadData()
      });
    },
    selectTo(item) {
      this.selectedTo = item.item.value
      this.$nextTick(() => {
        this.loadData()
      });
    },
    selectStatus(item) {
      this.selectedStatus = item.item.value
      this.$nextTick(() => {
        this.loadData()
      });
    },
    changePage (selected) {
      this.$data.currentPage = selected;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      history.pushState(null, null, '?page=' + selected);
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
  .hostCampaign {
    .emptySelection {
      margin-top: 120px;
    }
  }
</style>